import React from "react";

const LVFooter: React.FunctionComponent = () => {
  return <></>;
};

export default LVFooter;
